import { render, staticRenderFns } from "./TimeDoctor2ConnectView.vue?vue&type=template&id=3945a5da"
import script from "./TimeDoctor2ConnectView.vue?vue&type=script&lang=js"
export * from "./TimeDoctor2ConnectView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports